import { Utils } from "@/plugins/utils"
import moment from "moment"

export default {
	namespaced: true,
	state: {
		lstcfh: [],
		cfh: {
			cfhid: "",
			cfhcliente: "",
			cfhnome: "",
			cfhcriacao: null,
		},
		lstCfb: [],
		loading: false,
		itemsPerPage: 20,
		searchParams: {
			search: "",
			cfhcliente: "",
			since: moment().format("YYYY-MM-DD 00:00"),
			until: moment().format("YYYY-MM-DD 23:59"),
		},
		hasNext: false,
	},
	getters: {
		isInUpdateState: state => {
			const { cfhid, cfhcliente } = state.cfh
			return !!cfhid?.toString().trim() && !!cfhcliente?.toString().trim()
		},

		isInInsertState: (state, getters) => !getters.isInUpdateState,
	},
	mutations: {
		setLoading(state, value) {
			state.loading = value
		},
		initForm(state) {
			state.cfh = {}		
			state.cfh.cfhid = ""
			state.cfh.cfhcliente = ""
			state.cfh.cfhnome = ""
			state.cfh.cfhcriacao = null
		},
		setParamsDataTable(state, payload) {
			state.lstcfh = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
		set(state, cfh) {
			state.cfh = cfh
		},
	},
	actions: {
		async find(store, { cfhcliente, cfhid }) {
			store.commit("setLoading", true)

			await this._vm.$axios
				.get(`/Customer/ShippingAddressGroups/Find/${cfhcliente}/${cfhid}`)
				.then(response => {
					store.commit("set", Utils.ValidateAxiosResponse(response.data))
				})
				.catch(error => {
					store.dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
				})
				.finally(() => {
					store.commit("setLoading", false)
				})
		},
		async save({ getters, state, dispatch, commit }, newList) {
			if (getters["isInInsertState"]) {
				dispatch(
					"parameters/openGlobalLoading",
					{ showLoadingGlobal: true, text: "Inserindo", indeterminate: true },
					{ root: true },
				)
				await this._vm.$axios
					.post("/Customer/ShippingAddressGroups/Insert", state.cfh, {
						params: { cfbIds: newList },
						paramsSerializer: params => params.cfbIds.map(v => `cfbIds=${encodeURIComponent(v)}`).join("&"),
					})
					.then(async response => {
						commit("set", Utils.ValidateAxiosResponse(response.data))
					})
					.catch(error => {
						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: error.message,
							},
							{ root: true },
						)
						return false
					})
				dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			} else {
				dispatch(
					"parameters/openGlobalLoading",
					{ showLoadingGlobal: true, text: "Salvando", indeterminate: true },
					{ root: true },
				)
				await this._vm.$axios
					.put("/Customer/ShippingAddressGroups/Update", state.cfh, {
						params: { cfbIds: newList },
						paramsSerializer: params => params.cfbIds.map(v => `cfbIds=${encodeURIComponent(v)}`).join("&"),
					})
					.then(async response => {
						commit("set", Utils.ValidateAxiosResponse(response.data))
					})
					.catch(error => {
						dispatch(
							"parameters/openDialog",
							{
								titleText: "Erro",
								titleColor: "red",
								text: error.message,
							},
							{ root: true },
						)
						return false
					})
				dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
			}
		},
		async search(store, { limit = 20, page = 1 }) {
			store.commit("setLoading", true)

			const params = {
				...store.state.searchParams,
				limit,
				page,
			}

			try {
				const response = await this._vm.$axios.get("/Customer/ShippingAddressGroups/Search", { params })
				const payload = Utils.ValidateAxiosResponse(response.data)
				store.commit("setParamsDataTable", payload)
				return true
			} catch (error) {
				store.state.lstcfb = []
				store.dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return false
			} finally {
				store.commit("setLoading", false)
			}
		},
		async findAllCustomersWithGroups({ dispatch }, { text }) {
			try {
				const response = await this._vm.$axios.get("/Customer/ShippingAddressGroups/FindCustomersWithGroups", {
					params: {
						search: text
					}
				})
				return Utils.ValidateAxiosResponse(response.data)
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return []
			}
		},

		async canInsertName({ dispatch, state }, cfhnome) {
			try {
				const response = await this._vm.$axios.get("/Customer/ShippingAddressGroups/CanInsertName", {
					params: {
						cfhnome: cfhnome,
						cfhcliente: state.cfh.cfhcliente,
						cfhid: state.cfh.cfhid,
					},
				})
				return Utils.ValidateAxiosResponse(response.data)
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return []
			}
		},

		async findAllGroupsByCustomer({ dispatch }, { cfhcliente = null, text }) {
			try {
				const response = await this._vm.$axios.get("/Customer/ShippingAddressGroups/FindAllGroupsByCustomer", {
					params: { 
						cfhcliente: cfhcliente,
						search: text, 
					},
				})
				return Utils.ValidateAxiosResponse(response.data)
			} catch (error) {
				dispatch(
					"parameters/openDialog",
					{
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
					},
					{ root: true },
				)
				return []
			}
		},

		async deleteCfh({ dispatch, state, commit }) {
			dispatch(
				"parameters/openGlobalLoading",
				{ showLoadingGlobal: true, text: "Excluindo", indeterminate: true },
				{ root: true },
			)
			await this._vm.$axios
				.delete(`/Customer/ShippingAddressGroups/Delete/${state.cfh.cfhcliente}/${state.cfh.cfhid}`)
				.then(async response => {
					Utils.ValidateAxiosResponse(response.data)
					commit("set", {})
				})
				.catch(error => {
					dispatch(
						"parameters/openDialog",
						{
							titleText: "Erro",
							titleColor: "red",
							text: error.message,
						},
						{ root: true },
					)
					return false
				})
			dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, { root: true })
		},
	},
}
